import React from 'react';
import { useTranslation } from 'react-i18next';
import { SampleDto, SampleStatus } from '@src/types/types';
import { StatusStepSequence } from '../sample-details/StatusStepSequence';

interface ShipmentStatusProps {
  sample: SampleDto;
}

export const ShipmentStatus: React.FC<ShipmentStatusProps> = ({ sample }) => {
  const { t } = useTranslation('component', { keyPrefix: 'sampleDetails' });

  const steps = [
    {
      active: sample.status === SampleStatus.ACTIVATED,
      label: t('status.' + SampleStatus.ACTIVATED),
      date: sample.activatedAt,
    },
    {
      active: sample.status === SampleStatus.SHIPPED,
      label: t('status.' + SampleStatus.SHIPPED),
      date: sample.shippedAt,
    },
    {
      active: sample.status === SampleStatus.ARRIVED_IN_LAB,
      label: t('status.' + SampleStatus.ARRIVED_IN_LAB),
      date: sample.arrivedAt,
    },
    {
      active: sample.status === SampleStatus.DONE,
      label: t('status.' + SampleStatus.DONE),
      date: sample.resultsSince,
    },
  ];

  return (
    <div className="bg-grey3light rounded-xl p-6 h-max">
      <div className="flex justify-between items-start">
        <StatusStepSequence steps={steps} />
      </div>
    </div>
  );
};
